import React, { useState } from "react";
import Swal from "sweetalert2";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!formData.firstname.trim())
      newErrors.firstname = "First name is required";

    if (!formData.lastname.trim())
      newErrors.lastname = "Last name is required";

    if (!formData.email.trim())
      newErrors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Enter a valid email";

    if (!formData.phone.trim())
      newErrors.phone = "Mobile number is required";
    else if (!/^[0-9]{10}$/.test(formData.phone))
      newErrors.phone = "Enter valid 10 digit number";

    if (!formData.message.trim())
      newErrors.message = "Message is required";

    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    setErrors({
      ...errors,
      [e.target.name]: ""
    });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  const formErrors = validate();

  if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);

    Swal.fire({
      icon: "error",
      title: "Validation Error",
      text: "Please fill all required fields correctly"
    });
    return;
  }

  try {
    setLoading(true);

    const response = await fetch("/sendMail.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        formType: "contact",
        ...formData
      })
    });

    const data = await response.json();

    if (data.success) {
      Swal.fire("Success", "Message Sent Successfully", "success");

      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        message: ""
      });

      setErrors({});
    } else {
      Swal.fire("Error", "Mail not sent", "error");
    }

  } catch (error) {
    Swal.fire("Error", "Server not responding", "error");
  } finally {
    setLoading(false);
  }
};

  return (
    <form onSubmit={handleSubmit} className="contact-form">

      {/* First & Last Name */}
      <div className="name-row">
        <div>
          <label className="form-label">First Name</label>
          <input
            type="text"
            name="firstname"
            placeholder="First Name"
            value={formData.firstname}
            onChange={handleChange}
          />
          {errors.firstname && <p className="error">{errors.firstname}</p>}
        </div>

        <div>
          <label className="form-label">Last Name</label>
          <input
            type="text"
            name="lastname"
            placeholder="Last Name"
            value={formData.lastname}
            onChange={handleChange}
          />
          {errors.lastname && <p className="error">{errors.lastname}</p>}
        </div>
      </div>

      {/* Email + Phone */}
      <div className="name-row">
        <div>
          <label className="form-label">Email Address</label>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>

        <div>
          <label className="form-label">Mobile Number</label>
          <input
            type="text"
            name="phone"
            placeholder="Mobile Number"
            value={formData.phone}
            onChange={handleChange}
            maxLength="10"
          />
          {errors.phone && <p className="error">{errors.phone}</p>}
        </div>
      </div>

      {/* Message */}
      <div>
        <label className="form-label">Enter Message</label>
        <textarea
          className="message-input"
          name="message"
          placeholder="Message"
          rows="4"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        {errors.message && <p className="error">{errors.message}</p>}
      </div>

      <button
        className="contact-submit-button"
        type="submit"
        disabled={loading}
      >
        {loading ? "Sending..." : "Submit"}
      </button>

    </form>
  );
};

export default ContactForm;